/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nobusinessprofilefound3Inputs */

const en_nobusinessprofilefound3 = /** @type {(inputs: Nobusinessprofilefound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No business profile found`)
};

const de_nobusinessprofilefound3 = /** @type {(inputs: Nobusinessprofilefound3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Unternehmensprofil gefunden`)
};

/**
* | output |
* | --- |
* | "No business profile found" |
*
* @param {Nobusinessprofilefound3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nobusinessprofilefound3 = /** @type {((inputs?: Nobusinessprofilefound3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nobusinessprofilefound3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nobusinessprofilefound3(inputs)
	return de_nobusinessprofilefound3(inputs)
});
export { nobusinessprofilefound3 as "noBusinessProfileFound" }